export const getRootDomain = () => window.location.hostname.substring(window.location.hostname.indexOf(".") + 1);

export const isLocalhost = () => window.location.host.startsWith("localhost.saysimple-test.nl");
